import { Box } from '@mui/material';

// 정렬 아이콘 컴포넌트
export const SortIcon = ({ sortConfig, columnKey }) => {
    if (sortConfig.key !== columnKey) {
        return (
            <Box sx={{ ml: 1, opacity: 0.3 }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M3 4.5L6 1.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3 7.5L6 10.5L9 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Box>
        );
    }

    return (
        <Box sx={{ ml: 1, opacity: 1 }}>
            {sortConfig.direction === 'asc' ? (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M3 4.5L6 1.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ) : (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M3 7.5L6 10.5L9 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )}
        </Box>
    );
};